@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../tooltip/style.scss' as *;
@use '../@shared/pagination.mixin' as *;

@layer kol-component {
	@include kol-pagination-styles;
}
